// Apple-style "liquid glass" header: on mobile viewports, once the hero
// section has scrolled out of view the header morphs into a floating frosted
// pill. This module holds the pure decision logic so it can be unit-tested
// without a DOM/provider tree; the AppHeader hook just wires it to scroll.

// A viewport is "mobile" for the liquid header if it is a narrow portrait
// screen OR a short landscape screen (i.e. a phone turned sideways: wide but
// only ~390–500px tall). Without the landscape clause a phone in landscape
// (e.g. 844×390) never matched `max-width: 768px`, so the floating pill never
// appeared and the fixed top navbar stayed put.
export const LIQUID_MEDIA_QUERY =
  '(max-width: 768px), (orientation: landscape) and (max-height: 560px)';

export const HERO_SELECTOR = [
  '[data-hero]',
  '[data-hero-section]',
  '.hero',
  '.wk-hero',
  '.ov-hero',
  'header.hero',
  'section.hero',
].join(', ');

export function isMobileViewport(matchMediaFn) {
  if (typeof matchMediaFn !== 'function') return false;
  try {
    const mq = matchMediaFn(LIQUID_MEDIA_QUERY);
    return Boolean(mq && mq.matches);
  } catch (err) {
    return false;
  }
}

// Bottom edge of the hero in document coordinates. When no hero element is
// present, fall back to roughly one viewport of scrolling so every page gets
// the same behaviour.
export function findHeroBottom(doc, scrollY, fallbackViewportHeight) {
  const fallback = fallbackViewportHeight * 0.85;
  if (!doc || typeof doc.querySelector !== 'function') return fallback;
  const hero = doc.querySelector(HERO_SELECTOR);
  if (hero && typeof hero.getBoundingClientRect === 'function') {
    return hero.getBoundingClientRect().bottom + scrollY;
  }
  return fallback;
}

export function shouldUseLiquidHeader({ mobile, scrollY, heroBottom }) {
  return Boolean(mobile) && scrollY > heroBottom;
}
